import { Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { RoomBoxColour } from "../../constants/pojoservice";
import DialogBox from "../../global/DialogBox";

const RoomTableData = ({ dialog,
    billData,
    checkInDateChange, changedDate,
    billingDataList,
    handleOnClickRemove,
}) => {


    const renderBillingData = () => {
        return (
            <Grid container spacing={0.5}>
                <Grid item xs={12}>
                    <Typography variant="p" style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                        fontSize: "12px", color: "#2f1160"
                    }}>
                        These Rooms are not available in current selected date {checkInDateChange ? `(${changedDate} - ${billData.checkoutDate})` : `(${billData.checkInDate} - ${changedDate})`}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} elevation={3} sx={{
                        maxHeight: 300,
                        overflowY: "auto",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                        border: "none",
                        borderRadius: 2,
                    }}
                    >
                        <Table aria-label="extra-orders-table">
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: "#01333e",
                                    "& .MuiTableCell-root": {
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: "0.8rem",
                                        padding: "6px 8px",
                                        borderBottom: "none",
                                    },
                                }}>
                                    <TableCell align="center">Room Details</TableCell>
                                    <TableCell align="center">T.Amt</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {billingDataList.length === 0 ? (
                                    <TableRow>
                                        <TableCell align="center" colSpan={7}>
                                            <Typography variant="body2" color="text.secondary">
                                                No items yet. Add some above.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    billingDataList.map((r) => (
                                        <TableRow key={`${r.id}::${r.rateId}`} sx={{ backgroundColor: RoomBoxColour(r) }}>
                                            <TableCell align="center">{`${r.name ?? ""}`}</TableCell>
                                            <TableCell align="center">{`${r.totalRoomPrice ?? ""}`}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="p" style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                        fontSize: "12px", color: "#410f09ff"
                    }}>
                        * Remove : It will remove the room from current bill .
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="p" style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                        fontSize: "12px", color: "#410f09ff"
                    }}>
                        * Dismiss : It will change to previously configured date.
                    </Typography>
                </Grid>
            </Grid>
        )
    };

    const renderAction = () => {
        return (
            <Stack direction="row" spacing={1} justifyContent="center">
                <Button
                    size="small"
                    variant="contained"
                    onPointerDown={() => handleOnClickRemove(true)}
                >
                    Remove
                </Button>
                <Button
                    size="small"
                    variant="outlined"
                    onPointerDown={() => handleOnClickRemove(false)}
                >
                    Dismiss
                </Button>
            </Stack>
        )
    }

    return (
        <DialogBox
            showDialog={dialog}
            title={"!"}
            outsideClickedDismiss={false}
            dialogContent={renderBillingData()}
            dialogActions={renderAction()}
        />
    )
};

export { RoomTableData };